import { Switch } from "@maxhub/max-ui";

export const SwitchExample = {
    title: 'Switch',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'disabled',
            label: 'disabled',
            type: 'boolean',
            tsType: 'boolean',
            default: false
        },
    ],

    Preview({ props }){
        return (<Switch {...props}/>)
    },

    getCode(){
        return `<Switch/>`
    }

}